<template>
    <div class="go-back" v-show="showTopBtn" @click="goBackTop"></div>
</template>

<script>
    export default {
        data () {
            return {
                showTopBtn: false
            }
        },
        mounted () {
            window.addEventListener('scroll', this.initScroll);
            this.goBackTop();
        },
        destroyed () {
            window.removeEventListener('scroll', this.initScroll);
        },
        methods: {
            initScroll () {
                let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
                if (scrollTop > 500) {
                    this.showTopBtn = true;
                } else {
                    this.showTopBtn = false;
                }
            },
            goBackTop () {
                $('html,body').animate({
                    scrollTop: 0
                }, 600)
            }
        }
    }
</script>

<style scoped lang="scss">
.go-back{
    position: fixed;
    bottom: 51px;
    right: 96px;
    z-index: 222;
    width: 52px;
    height: 52px;
    border-radius: 26px;
    box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.10); 
    background: #fff;
    background-image: url('../../images/community/angle-up.png');
    background-size: 32px 32px;
    background-position: 50% 50%;
    background-repeat: no-repeat;
    cursor: pointer;
    &:hover {
      background-image: url('../../images/community/hover-angle-up.png');
    }
 }
</style>


// WEBPACK FOOTER //
// goback.vue?623c5c6c